module.exports = __webpack_public_path__ + "img/lsr_text.26876019.svg";